import FactorActivityRenderer from "./FactorActivityRenderer";
import FactorActivityPopupRenderer from "./FactorActivityPopupRenderer";

export default FactorActivityRenderer;

export { FactorActivityPopupRenderer };
